<template>
    <div>
        <b-container fluid class="mt-2 px-1 px-sm-3 pb-2 team-page">
            <b-row>
                <b-col cols="" class="">
                    <b-row>
                        <b-col cols="">
                            <div class="expiry-data d-flex justify-content-between align-items-center flex-wrap mb-3">
                                <h2 class="text-left mb-0">{{ $t('recruitingPage.tabJobs') }}</h2>
                                <div class="justify-content-between justify-content-sm-center flex-wrap">
                                    <b-button @click="addRecruitingRecord()"
                                        class="export equipment d-flex justify-content-center align-items-center mx-1 my-1 w-fit-content"
                                        variant="primary">
                                        <b-icon icon="plus" aria-hidden="true"></b-icon>
                                        <p class="mb-0 ml-2 text-white">{{ $t('recruitingPage.addJob') }}</p>
                                    </b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div class="data-table team-data-table table-custom-border">
                                <div class="bg-white pt-3 pt-sm-4 rounded">
                                    <div class="table_row team_table_row">
                                        <div class="equipment-border filter-box">
                                            <div class="d-flex mb-4 px-3 px-sm-4">
                                                <b-form-group class="text-left label font-weight-normal search-field mb-0">
                                                    <b-input-group class="username-input-field">
                                                        <b-form-input type="text" :placeholder="$t('recruitingPage.search')"
                                                            v-model="filterFields.search" class="unit f-12"
                                                            @keyup.enter="getAllRecruitingData()"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-button variant="primary" @click="getAllRecruitingData()">
                                                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path
                                                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                                                        stroke="white" stroke-width="2"
                                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10 10.5L13 13.5" stroke="white"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                                </svg>
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                </b-form-group>
                                                <div class="ml-auto align-items-center d-none d-sm-flex flex-wrap">
                                                    <div class="position-relative">
                                                        <div class="position-absolute notification-badge"
                                                            v-if="activeFiltersCount">
                                                            {{ activeFiltersCount }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="!isTableMounted" class="mt-2"
                                            style="height: calc(100vh - 280px); overflow: hidden;">
                                            <b-skeleton-table :rows="17" :columns="7"
                                                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
                                        </div>
                                        <b-table v-else ref="tableRef" class="mt-2" responsive :fields="translatedFields"
                                            :items="items" hover :sticky-header="'calc(100vh - 280px)'"
                                            :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                            :no-local-sorting="true" :busy.sync="isBusy" :show-empty="emptyTable">
                                            <template #cell(status)="data">
                                                <b-button
                                                    class="btn f-14 pe-none d-flex justify-content-center align-items-center"
                                                    :variant="data.item.status === 'New Lead' || data.item.status === 'Applied' ? 'warning-status' : data.item.status === 'Rejected' ? 'danger-status' : data.item.status === 'Contacted' || data.item.status === 'Under Review' || data.item.status === 'Hired' ? 'primary-status' : data.item.status === 'In Progress' || data.item.status === 'Screening' ? 'success-status' : 'secondary-status'">
                                                    <p class="mb-0">{{ data.item.status }}</p>
                                                </b-button>
                                            </template>
                                            <template #cell(action)="data">
                                                <div>
                                                    <svg @click="copyJobLink(data.item.job_link)" width="30" height="28"
                                                        viewBox="0 0 18 18" class="mr-2 mt-1 cursor-pointer" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M9.84375 10.7813V12.8906C9.84375 13.2788 9.52875 13.5938 9.14062 13.5938H3.04688C2.86039 13.5938 2.68155 13.5197 2.54969 13.3878C2.41783 13.2559 2.34375 13.0771 2.34375 12.8906V4.92188C2.34375 4.53375 2.65875 4.21875 3.04688 4.21875H4.21875C4.53286 4.21854 4.84644 4.24446 5.15625 4.29625M9.84375 10.7813H11.9531C12.3412 10.7813 12.6562 10.4663 12.6562 10.0781V7.03125C12.6562 4.24375 10.6294 1.93063 7.96875 1.48375C7.65894 1.43196 7.34536 1.40604 7.03125 1.40625H5.85938C5.47125 1.40625 5.15625 1.72125 5.15625 2.10938V4.29625M9.84375 10.7813H5.85938C5.67289 10.7813 5.49405 10.7072 5.36219 10.5753C5.23033 10.4434 5.15625 10.2646 5.15625 10.0781V4.29625M12.6562 8.4375V7.26563C12.6562 6.70619 12.434 6.16966 12.0384 5.77407C11.6428 5.37849 11.1063 5.15625 10.5469 5.15625H9.60938C9.42289 5.15625 9.24405 5.08217 9.11219 4.95031C8.98033 4.81845 8.90625 4.63961 8.90625 4.45313V3.51563C8.90625 3.23862 8.85169 2.96432 8.74568 2.7084C8.63968 2.45248 8.4843 2.21995 8.28843 2.02407C8.09255 1.8282 7.86002 1.67282 7.6041 1.56682C7.34818 1.46081 7.07388 1.40625 6.79688 1.40625H6.09375"
                                                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round"></path>
                                                    </svg>
                                                    <svg @click="setJobData(data)" class="mr-3 cursor-pointer" width="18"
                                                        height="18" viewBox="0 0 18 18" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M5.52719 16.7477L14.5274 7.74753L10.2525 3.4726L1.25226 12.4728C1.12836 12.5969 1.04034 12.7522 0.997548 12.9222L0 18L5.07684 17.0025C5.2473 16.9598 5.40322 16.8717 5.52719 16.7477V16.7477ZM17.4329 4.84205C17.796 4.47881 18 3.98622 18 3.4726C18 2.95898 17.796 2.46639 17.4329 2.10315L15.8968 0.567123C15.5336 0.203994 15.041 0 14.5274 0C14.0138 0 13.5212 0.203994 13.1579 0.567123L11.6219 2.10315L15.8968 6.37808L17.4329 4.84205Z"
                                                            fill="#2CCE89" />
                                                    </svg>
                                                    <svg @click="showJobDeletePopupModal(data.item.id)"
                                                        class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000"
                                                            stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </template>

                                        </b-table>
                                        <div class="entries-pagination px-0 px-sm-2">
                                            <div class="d-flex align-items-center flex-wrap">
                                                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                                                    <b-form-select v-model="perPage" :options="pageOptions" />
                                                </div>
                                                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">
                                                    {{ positionText }}
                                                </p>
                                                <div class="pagination">
                                                    <b-pagination v-model="currentPage" :total-rows="rows"
                                                        :per-page="perPage" aria-controls="my-table"></b-pagination>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('recruitingPage.filtersModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('recruitingPage.statusLabel')" class="text-left select_arrow label mb-0">
                    <b-form-select class="input f-12 mb-3" :options="statusFilterOptions" v-model="filterFields.status"
                        @change="getAllRecruitingData()"></b-form-select>
                </b-form-group>

            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('recruitingPage.reset')
                        }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block @click="$bvModal.hide('modal-filter')">{{
                        $t('recruitingPage.close') }}</b-button>
                </div>
            </template>
        </b-modal>
        <JobRecord :jobData="jobData" @updateJobData="jobData = null" @refreshJobs="getAllRecruitingData" />
        <DeleteModal v-if="showJobDeletePopup" @confirm="deleteJob($event)" />
    </div>
</template>
<script>
import * as moment from "moment-timezone";
import { mapActions, mapGetters } from "vuex";
import 'vue2-datepicker/index.css';
import JobRecord from '@/components/Recruiting/JobRecord.vue';
import DeleteModal from "@/components/DeleteModal.vue";
export default {
    name: "HazmatCheck",
    components: { JobRecord, DeleteModal },
    data() {
        return {
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            searchName: null,
            jobID: null,
            jobData: null,
            allowAddLead: false,
            leadID: null,
            showJobDeletePopup: false,
            searchType: null,
            currentPage: 1,
            sortBy: undefined,
            isTableMounted: false,
            defaultData: {},
            sortDesc: undefined,
            emptyTable: false,
            isBusy: false,
            rows: 1,
            positionText: "",
            items: [],
            showDivision: false,
            showPublic: false,
            modelType: null,
            isTagDoc: false,
            archivedDocsCount: 0,
            sendCount: 0,
            receivedCount: 0,
            perPage: 25,
            selectedRows: [],
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
            filterFields: {
                search: '',
                status: ''
            },
            jobsCount: 0,
            errors: {
                date: null,
                name: null,
                document: null,
            },
            nameOptions: [],
        };
    },
    computed: {
        ...mapGetters(["company"]),
        translatedFields() {

            return [
                { label: this.$t('recruitingPage.columnName'), key: "name", sortable: true, thClass: 'font-table-weight-bold', stickyColumn: true },
                { label: this.$t('recruitingPage.columnCompanyName'), key: "company_name", sortable: true, thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingPage.columnAddress'), key: "company_address", sortable: true, thClass: 'font-table-weight-bold' },
                { label: this.$t('recruitingPage.columnPhone'), key: "company_phone", sortable: true, thClass: 'font-table-weight-bold' },
                { key: "Action", label: this.$t('recruitingPage.columnAction'), sortable: true, thClass: 'font-table-weight-bold' },
            ]
        },
        getNumberofAllowedJobs() {
            return this.company[0]?.number_of_allowed_jobs
        },
        statusFilterOptions() {
            const opts = [{ value: '', text: '' }];
            return opts;
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
    },
    methods: {
        ...mapActions([
            "setLoader",
            "setNotification",
            "getRecruitingData",
            "deleteJobData"
        ]),
        htmlToPlainText(htmlString) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = htmlString;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async copyJobLink(url) {
            if (url) {
                try {
                    await navigator.clipboard.writeText(url);
                    await this.setNotification({
                        msg: this.$t('recruitingPage.appLinkCopied'),
                        type: "success",
                        color: "green",
                    });
                } catch (e) {
                    console.log(e)
                }
            }
        },
        setJobData(data) {
            this.jobData = data.item
            this.$bvModal.show('modal-job-record');
        },
        async deleteJob(status) {
            if (status) {
                try {
                    await this.deleteJobData(`${this.jobID}/?company_id=${this.userCompany}`)
                    await this.setNotification({
                        msg: this.$t('recruitingPage.jobDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.jobID = null
                    this.showJobDeletePopup = false;
                    await this.getAllRecruitingData()
                }
                catch (error) {
                    this.jobID = null
                    this.showJobDeletePopup = false;
                    if (typeof error === "object" && error.error) {
                        await this.setNotification({
                            msg: error.error,
                            type: "error",
                            color: "red",
                        });
                    }
                }
            }
            else this.showJobDeletePopup = false
        },
        showJobDeletePopupModal(id) {
            this.showJobDeletePopup = true;
            this.jobID = id;
        },
        addRecruitingRecord() {
            if (this.jobsCount >= this.getNumberofAllowedJobs) {
                this.setNotification({
                    msg: this.$t('recruitingPage.jobLimitReached'),
                    type: "error",
                    color: "red",
                });
                return;
            }
            this.$bvModal.show('modal-job-record');

        },
        setTab(tab) {
            this.tab = tab;
            this.resetFilterFields();
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                status: ''
            }
            await this.getAllRecruitingData();
        },
        async getAllRecruitingData() {
            try {
                this.items = []
                this.isBusy = true
                let url = ""
                Object.keys(this.filterFields).map((key) => {
                    if (this.filterFields[key] !== '') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }

                url += `page=${this.currentPage}&page_size=${this.perPage}&tab=${this.tab}`
                const data = await this.getRecruitingData({ type: 'job', url, company_id: this.userCompany });
                this.items = []
                this.jobsCount = data.counts.jobs >= 0 ? data.counts.jobs : 0
                if (data.total_entries_count) {
                    data.data.forEach((item) => {
                        this.items.push({
                            id: item.id,
                            name: item.name,
                            company_name: item.company_name,
                            company_address: item.company_address,
                            company_phone: item.company_phone,
                            job_link: item.job_link,
                            requirements: item.requirements,
                            app_type: item.app_type,
                            employer_required: item.employer_required
                        })
                    })

                    this.rows = data.total_entries_count
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('recruitingPage.positionText', { start, end, total: data.total_entries_count })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('recruitingPage.emptyPosition')
                }
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isTableMounted = true
                this.isBusy = false
                console.log(e)
            }
        },

    },
    watch: {
        perPage: {
            async handler() {
                await this.getAllRecruitingData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        sortBy: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getAllRecruitingData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },

    },
};
</script>
<style>
.note-tooltip-content {
    max-width: 320px;
    white-space: normal;
    word-break: break-word;
    line-height: 1.4;
}
</style>
